// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beer-share-container{
    background-color: rgba(0, 0, 0, 0.649);
    display: flex;
    position: fixed;
    z-index: 5;
    width: 100%;
    height: 100vh;
    align-items: center;
    justify-content: center;
  }
.beer-sub-container{
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 17%;
    border: .75px rgb(0, 0, 0) solid;
    width: 73%;
    height: auto;
    background-color: rgb(255, 255, 255);
}
.header{
    font-size: 6vw;
    font-family: 'Helvetica-Reg';
    font-weight: 400;
    letter-spacing: .15vw;
    color: rgb(0, 0, 0);
}
.fb, .linked, .email, .url{
    width: 77%;
    padding-top: 11%;
    padding-bottom: 11%;
    background-color: rgba(255, 255, 255, 0);
    display: flex;
    align-items: center;
    justify-content: end;
    cursor: pointer;
    text-decoration: none;
}
.url, .fb, .email{
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom: 1px solid rgb(220, 221, 221);
}
.linked{
    border: 0;
}
.url-img{
    height: 7.5vw;
    width: auto;
    margin-right: 10%;
}
.fb-img{
    height: 8vw;
    width: auto;
    margin-right: 10%;
}
.email-image{
    height: 6vw;
    margin-right: 10%;
}
.menu-label{
    font-family: 'Helvetica-Reg';
    font-weight: 500;
    letter-spacing: .02vw;
    font-size: 5.5vw;
    line-height: 5.5vw;
    display: flex;
    padding: 0;
    margin: 3% 0 0 0;
    color: black;
}
.close-label{
    font-family: 'Helvetica-Reg';
    font-weight: 500;
    letter-spacing: .02vw;
    font-size: 5.5vw;
    line-height: 6.25vw;
    display: flex;
    align-items: center;
    padding: 0;
    margin: 2% 0 0 0;
    color: white;
}
.option{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
}
.close-option{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.close-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: none;
    background-color: black;
    padding-top: 6%;
    padding-bottom: 6%;
    cursor: pointer;
}
.close-img{
    height: 5.5vw;
    width: auto;
    margin-right: 6%;
}
.highlight{
    width: 100%;
    height: 1vw;
}
.share-container {
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;
}
/* Menu open state */
.share-container.visible {
    display: flex;
    opacity: 1;
    visibility: visible;
}
/* Menu closing state */
.share-container.hidden {
    opacity: 0;
    visibility: hidden;
}

@media only screen and (min-width: 700px) and (min-height: 1000px){

    .beer-share-container{
        background-color: rgba(0, 0, 0, 0.948);
        display: flex;
        position: fixed;
        z-index: 5;
        width: 100%;
        height: 100vh;
        align-items: center;
        justify-content: center;
      }
    .beer-sub-container{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 20%;
        border: 0px rgb(0, 0, 0) solid;
        width: 45%;
        height: auto;
        background-color: rgb(255, 255, 255);
    }
    .header{
        font-size: 5vw;
        font-family: 'Helvetica-Reg';
        font-weight: 400;
        letter-spacing: .15vw;
        color: rgb(0, 0, 0);
    }
    .fb, .linked, .email, .url{
        width: 75%;
        padding-top: 8%;
        padding-bottom: 8%;
        background-color: rgba(255, 255, 255, 0);
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .url, .fb, .email{
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-bottom: 1px solid rgb(220, 221, 221);
    }
    .linked{
        border: 0;
    }
    .url-img{
        height: 5.5vw;
        width: auto;
        margin-right: 15%;
    }
    .fb-img{
        height: 5.5vw;
        width: auto;
        margin-right: 14%;
    }
    .email-image{
        height: 4.2vw;
        margin-right: 14%;
    }
    .menu-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .02vw;
        font-size: 3vw;
        line-height: 6.25vw;
        display: flex;
        padding: 0;
        margin: 3% 0 0 0;
    }
    .close-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .02vw;
        font-size: 3vw;
        line-height: 4.75vw;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 2% 0 0 0;
        color: white;
    }
    .option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
    }
    .close-option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: none;
        background-color: black;
        padding-top: 5%;
        padding-bottom: 5%;
        border: none;
    }
    .close-img{
        height: 3.25vw;
        width: auto;
        margin-right: 5%;
    }
    .highlight{
        width: 100%;
        height: .75vw;
    }
    .share-container {
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;
    }
    /* Menu open state */
    .share-container.visible {
        display: flex;
        opacity: 1;
        visibility: visible;
    }
    /* Menu closing state */
    .share-container.hidden {
        opacity: 0;
        visibility: hidden;
    }
}
@media only screen and (min-width: 1000px){
    .beer-share-container{
        background-color: transparent;
        display: flex;
        position: fixed;
        z-index: 5;
        left: 24.5%;
        top: 10.5vh;
        width: 160px;
        height: auto;
        align-items: center;
        justify-content: center;
        border: none;
      }
    .beer-sub-container{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 0vh;
        border: 0px rgb(0, 0, 0) solid;
        width: 100%;
        height: auto;
        background-color: rgb(255, 255, 255);
        box-shadow: 1px 1px 5px rgb(138, 138, 138);
    }
    .header{
        font-size: 5vw;
        font-family: 'Helvetica-Reg';
        font-weight: 400;
        letter-spacing: .15vw;
        color: rgb(0, 0, 0);
    }
    .fb, .linked, .email, .url{
        width: 75%;
        padding-top: 7%;
        padding-bottom: 7%;
        background-color: rgba(255, 255, 255, 0);
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .url, .fb, .email{
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-bottom: 1px solid rgb(220, 221, 221);
    }
    .linked{
        border: 0;
    }
    .url-img{
        height: 19px;
        width: auto;
        margin-right: 12%;
    }
    .fb-img{
        height: 20px;
        width: auto;
        margin-right: 12%;
    }
    .email-image{
        height: 15px;
        margin-right: 12%;
    }
    .menu-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .25px;
        font-size: 15px;
        line-height: 22px;
        display: flex;
        padding: 0;
        margin: 3% 0 0 0;
    }
    .close-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .02vw;
        font-size: 15px;
        line-height: 26px;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 2% 0 0 0;
        color: white;
    }
    .option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
    }
    .close-option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: none;
        background-color: black;
        padding-top: 2%;
        padding-bottom: 2%;
        border: none;
    }
    .close-img{
        height: 13px;
        width: auto;
        margin-right: 6%;
    }
    .highlight{
        width: 100%;
        height: 3px;
    }
    .share-container {
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;
    }
    /* Menu open state */
    .share-container.visible {
        display: flex;
        opacity: 1;
        visibility: visible;
    }
    /* Menu closing state */
    .share-container.hidden {
        opacity: 0;
        visibility: hidden;
    }
}
@media screen and (min-width: 1400px){
    .beer-share-container{
        background-color: transparent;
        display: flex;
        position: fixed;
        z-index: 5;
        left: 25%;
        top: 10.25vh;
        width: 174px;
        height: auto;
        align-items: center;
        justify-content: center;
        border: none;
      }
    .beer-sub-container{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 0vh;
        border: 0px rgb(0, 0, 0) solid;
        width: 100%;
        height: auto;
        background-color: rgb(255, 255, 255);
        box-shadow: 1px 1px 5px rgb(138, 138, 138);
    }
    .fb, .linked, .email, .url{
        width: 75%;
        padding-top: 8%;
        padding-bottom: 8%;
        background-color: rgba(255, 255, 255, 0);
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .url, .fb, .email{
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-bottom: 1px solid rgb(220, 221, 221);
    }
    .linked{
        border: 0;
    }
    .url-img{
        height: 20px;
        width: auto;
        margin-right: 13%;
    }
    .fb-img{
        height: 21px;
        width: auto;
        margin-right: 13%;
    }
    .email-image{
        height: 16px;
        margin-right: 13%;
    }
    .menu-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .25px;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        padding: 0;
        margin: 3% 0 0 0;
    }
    .close-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .02vw;
        font-size: 16px;
        line-height: 30px;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 2% 0 0 0;
        color: white;
    }
    .option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
    }
    .close-option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: none;
        background-color: black;
        padding-top: 2.5%;
        padding-bottom: 2.5%;
        border: none;
    }
    .close-img{
        height: 13px;
        width: auto;
        margin-right: 6%;
    }
    .highlight{
        width: 100%;
        height: 3px;
    }
    .share-container {
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;
    }
    /* Menu open state */
    .share-container.visible {
        display: flex;
        opacity: 1;
        visibility: visible;
    }
    /* Menu closing state */
    .share-container.hidden {
        opacity: 0;
        visibility: hidden;
    }
}
@media screen and (min-width: 1900px){
    .beer-share-container{
        background-color: none;
        display: flex;
        position: fixed;
        z-index: 5;
        left: 25%;
        top: 8.76vh;
        width: 190px;
        height: auto;
        align-items: center;
        justify-content: center;
        border: none;
      }
    .beer-sub-container{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 0vh;
        border: none;
        width: 100%;
        height: auto;
        background-color: rgb(255, 255, 255);
        box-shadow: 1px 1px 5px rgb(138, 138, 138);
    }
    .fb, .linked, .email, .url{
        width: 75%;
        padding-top: 9.25%;
        padding-bottom: 9.25%;
        background-color: rgba(255, 255, 255, 0);
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .url, .fb, .email{
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-bottom: 1px solid rgb(220, 221, 221);
    }
    .linked{
        border: 0;
    }
    .url-img{
        height: 20px;
        width: auto;
        margin-right: 14%;
    }
    .fb-img{
        height: 23px;
        width: auto;
        margin-right: 13%;
    }
    .email-image{
        height: 15px;
        margin-right: 14%;
    }
    .menu-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .25px;
        font-size: 17px;
        line-height: 24px;
        display: flex;
        padding: 0;
        margin: 3% 0 0 0;
    }
    .close-label{
        font-family: 'Helvetica-Reg';
        font-weight: 500;
        letter-spacing: .25px;
        font-size: 17px;
        line-height: 30px;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 2.25% 0 0 0;
        color: white;
    }
    .option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
    }
    .close-option{
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: none;
        background-color: black;
        padding-top: 4.25%;
        padding-bottom: 4.25%;
        border: none;
    }
    .close-img{
        height: 15px;
        width: auto;
        margin-right: 6%;
    }
    .highlight{
        width: 100%;
        height: 3px;
    }
    .share-container {
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;
    }
    /* Menu open state */
    .share-container.visible {
        display: flex;
        opacity: 1;
        visibility: visible;
    }
    /* Menu closing state */
    .share-container.hidden {
        opacity: 0;
        visibility: hidden;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/beerShare.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,aAAa;IACb,eAAe;IACf,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,2CAA2C;AAC/C;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,gEAAgE;AACpE;AACA,oBAAoB;AACpB;IACI,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;AACA,uBAAuB;AACvB;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI;QACI,sCAAsC;QACtC,aAAa;QACb,eAAe;QACf,UAAU;QACV,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;MACzB;IACF;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,8BAA8B;QAC9B,UAAU;QACV,YAAY;QACZ,oCAAoC;IACxC;IACA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;QAClB,wCAAwC;QACxC,aAAa;QACb,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,eAAe;QACf,cAAc;QACd,2CAA2C;IAC/C;IACA;QACI,SAAS;IACb;IACA;QACI,aAAa;QACb,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,aAAa;QACb,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;QACd,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,gEAAgE;IACpE;IACA,oBAAoB;IACpB;QACI,aAAa;QACb,UAAU;QACV,mBAAmB;IACvB;IACA,uBAAuB;IACvB;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,6BAA6B;QAC7B,aAAa;QACb,eAAe;QACf,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;MACd;IACF;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,8BAA8B;QAC9B,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,0CAA0C;IAC9C;IACA;QACI,cAAc;QACd,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;QAClB,wCAAwC;QACxC,aAAa;QACb,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,eAAe;QACf,cAAc;QACd,2CAA2C;IAC/C;IACA;QACI,SAAS;IACb;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,gEAAgE;IACpE;IACA,oBAAoB;IACpB;QACI,aAAa;QACb,UAAU;QACV,mBAAmB;IACvB;IACA,uBAAuB;IACvB;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,6BAA6B;QAC7B,aAAa;QACb,eAAe;QACf,UAAU;QACV,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;MACd;IACF;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,8BAA8B;QAC9B,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;QAClB,wCAAwC;QACxC,aAAa;QACb,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,eAAe;QACf,cAAc;QACd,2CAA2C;IAC/C;IACA;QACI,SAAS;IACb;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,iBAAiB;QACjB,oBAAoB;QACpB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,gEAAgE;IACpE;IACA,oBAAoB;IACpB;QACI,aAAa;QACb,UAAU;QACV,mBAAmB;IACvB;IACA,uBAAuB;IACvB;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,aAAa;QACb,eAAe;QACf,UAAU;QACV,SAAS;QACT,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;MACd;IACF;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,qBAAqB;QACrB,wCAAwC;QACxC,aAAa;QACb,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,eAAe;QACf,cAAc;QACd,2CAA2C;IAC/C;IACA;QACI,SAAS;IACb;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,4BAA4B;QAC5B,gBAAgB;QAChB,qBAAqB;QACrB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,gEAAgE;IACpE;IACA,oBAAoB;IACpB;QACI,aAAa;QACb,UAAU;QACV,mBAAmB;IACvB;IACA,uBAAuB;IACvB;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":[".beer-share-container{\n    background-color: rgba(0, 0, 0, 0.649);\n    display: flex;\n    position: fixed;\n    z-index: 5;\n    width: 100%;\n    height: 100vh;\n    align-items: center;\n    justify-content: center;\n  }\n.beer-sub-container{\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    top: 17%;\n    border: .75px rgb(0, 0, 0) solid;\n    width: 73%;\n    height: auto;\n    background-color: rgb(255, 255, 255);\n}\n.header{\n    font-size: 6vw;\n    font-family: 'Helvetica-Reg';\n    font-weight: 400;\n    letter-spacing: .15vw;\n    color: rgb(0, 0, 0);\n}\n.fb, .linked, .email, .url{\n    width: 77%;\n    padding-top: 11%;\n    padding-bottom: 11%;\n    background-color: rgba(255, 255, 255, 0);\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    cursor: pointer;\n    text-decoration: none;\n}\n.url, .fb, .email{\n    border-top: 0;\n    border-right: 0;\n    border-left: 0;\n    border-bottom: 1px solid rgb(220, 221, 221);\n}\n.linked{\n    border: 0;\n}\n.url-img{\n    height: 7.5vw;\n    width: auto;\n    margin-right: 10%;\n}\n.fb-img{\n    height: 8vw;\n    width: auto;\n    margin-right: 10%;\n}\n.email-image{\n    height: 6vw;\n    margin-right: 10%;\n}\n.menu-label{\n    font-family: 'Helvetica-Reg';\n    font-weight: 500;\n    letter-spacing: .02vw;\n    font-size: 5.5vw;\n    line-height: 5.5vw;\n    display: flex;\n    padding: 0;\n    margin: 3% 0 0 0;\n    color: black;\n}\n.close-label{\n    font-family: 'Helvetica-Reg';\n    font-weight: 500;\n    letter-spacing: .02vw;\n    font-size: 5.5vw;\n    line-height: 6.25vw;\n    display: flex;\n    align-items: center;\n    padding: 0;\n    margin: 2% 0 0 0;\n    color: white;\n}\n.option{\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n.close-option{\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.close-btn{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    border: none;\n    background-color: black;\n    padding-top: 6%;\n    padding-bottom: 6%;\n    cursor: pointer;\n}\n.close-img{\n    height: 5.5vw;\n    width: auto;\n    margin-right: 6%;\n}\n.highlight{\n    width: 100%;\n    height: 1vw;\n}\n.share-container {\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;\n}\n/* Menu open state */\n.share-container.visible {\n    display: flex;\n    opacity: 1;\n    visibility: visible;\n}\n/* Menu closing state */\n.share-container.hidden {\n    opacity: 0;\n    visibility: hidden;\n}\n\n@media only screen and (min-width: 700px) and (min-height: 1000px){\n\n    .beer-share-container{\n        background-color: rgba(0, 0, 0, 0.948);\n        display: flex;\n        position: fixed;\n        z-index: 5;\n        width: 100%;\n        height: 100vh;\n        align-items: center;\n        justify-content: center;\n      }\n    .beer-sub-container{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        top: 20%;\n        border: 0px rgb(0, 0, 0) solid;\n        width: 45%;\n        height: auto;\n        background-color: rgb(255, 255, 255);\n    }\n    .header{\n        font-size: 5vw;\n        font-family: 'Helvetica-Reg';\n        font-weight: 400;\n        letter-spacing: .15vw;\n        color: rgb(0, 0, 0);\n    }\n    .fb, .linked, .email, .url{\n        width: 75%;\n        padding-top: 8%;\n        padding-bottom: 8%;\n        background-color: rgba(255, 255, 255, 0);\n        display: flex;\n        align-items: center;\n        justify-content: end;\n    }\n    .url, .fb, .email{\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n        border-bottom: 1px solid rgb(220, 221, 221);\n    }\n    .linked{\n        border: 0;\n    }\n    .url-img{\n        height: 5.5vw;\n        width: auto;\n        margin-right: 15%;\n    }\n    .fb-img{\n        height: 5.5vw;\n        width: auto;\n        margin-right: 14%;\n    }\n    .email-image{\n        height: 4.2vw;\n        margin-right: 14%;\n    }\n    .menu-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .02vw;\n        font-size: 3vw;\n        line-height: 6.25vw;\n        display: flex;\n        padding: 0;\n        margin: 3% 0 0 0;\n    }\n    .close-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .02vw;\n        font-size: 3vw;\n        line-height: 4.75vw;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        margin: 2% 0 0 0;\n        color: white;\n    }\n    .option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: start;\n    }\n    .close-option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .close-btn{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        border: none;\n        background-color: black;\n        padding-top: 5%;\n        padding-bottom: 5%;\n        border: none;\n    }\n    .close-img{\n        height: 3.25vw;\n        width: auto;\n        margin-right: 5%;\n    }\n    .highlight{\n        width: 100%;\n        height: .75vw;\n    }\n    .share-container {\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;\n    }\n    /* Menu open state */\n    .share-container.visible {\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n    }\n    /* Menu closing state */\n    .share-container.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n}\n@media only screen and (min-width: 1000px){\n    .beer-share-container{\n        background-color: transparent;\n        display: flex;\n        position: fixed;\n        z-index: 5;\n        left: 24.5%;\n        top: 10.5vh;\n        width: 160px;\n        height: auto;\n        align-items: center;\n        justify-content: center;\n        border: none;\n      }\n    .beer-sub-container{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        top: 0vh;\n        border: 0px rgb(0, 0, 0) solid;\n        width: 100%;\n        height: auto;\n        background-color: rgb(255, 255, 255);\n        box-shadow: 1px 1px 5px rgb(138, 138, 138);\n    }\n    .header{\n        font-size: 5vw;\n        font-family: 'Helvetica-Reg';\n        font-weight: 400;\n        letter-spacing: .15vw;\n        color: rgb(0, 0, 0);\n    }\n    .fb, .linked, .email, .url{\n        width: 75%;\n        padding-top: 7%;\n        padding-bottom: 7%;\n        background-color: rgba(255, 255, 255, 0);\n        display: flex;\n        align-items: center;\n        justify-content: end;\n    }\n    .url, .fb, .email{\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n        border-bottom: 1px solid rgb(220, 221, 221);\n    }\n    .linked{\n        border: 0;\n    }\n    .url-img{\n        height: 19px;\n        width: auto;\n        margin-right: 12%;\n    }\n    .fb-img{\n        height: 20px;\n        width: auto;\n        margin-right: 12%;\n    }\n    .email-image{\n        height: 15px;\n        margin-right: 12%;\n    }\n    .menu-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .25px;\n        font-size: 15px;\n        line-height: 22px;\n        display: flex;\n        padding: 0;\n        margin: 3% 0 0 0;\n    }\n    .close-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .02vw;\n        font-size: 15px;\n        line-height: 26px;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        margin: 2% 0 0 0;\n        color: white;\n    }\n    .option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: start;\n    }\n    .close-option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .close-btn{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        border: none;\n        background-color: black;\n        padding-top: 2%;\n        padding-bottom: 2%;\n        border: none;\n    }\n    .close-img{\n        height: 13px;\n        width: auto;\n        margin-right: 6%;\n    }\n    .highlight{\n        width: 100%;\n        height: 3px;\n    }\n    .share-container {\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;\n    }\n    /* Menu open state */\n    .share-container.visible {\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n    }\n    /* Menu closing state */\n    .share-container.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n}\n@media screen and (min-width: 1400px){\n    .beer-share-container{\n        background-color: transparent;\n        display: flex;\n        position: fixed;\n        z-index: 5;\n        left: 25%;\n        top: 10.25vh;\n        width: 174px;\n        height: auto;\n        align-items: center;\n        justify-content: center;\n        border: none;\n      }\n    .beer-sub-container{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        top: 0vh;\n        border: 0px rgb(0, 0, 0) solid;\n        width: 100%;\n        height: auto;\n        background-color: rgb(255, 255, 255);\n        box-shadow: 1px 1px 5px rgb(138, 138, 138);\n    }\n    .fb, .linked, .email, .url{\n        width: 75%;\n        padding-top: 8%;\n        padding-bottom: 8%;\n        background-color: rgba(255, 255, 255, 0);\n        display: flex;\n        align-items: center;\n        justify-content: end;\n    }\n    .url, .fb, .email{\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n        border-bottom: 1px solid rgb(220, 221, 221);\n    }\n    .linked{\n        border: 0;\n    }\n    .url-img{\n        height: 20px;\n        width: auto;\n        margin-right: 13%;\n    }\n    .fb-img{\n        height: 21px;\n        width: auto;\n        margin-right: 13%;\n    }\n    .email-image{\n        height: 16px;\n        margin-right: 13%;\n    }\n    .menu-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .25px;\n        font-size: 16px;\n        line-height: 22px;\n        display: flex;\n        padding: 0;\n        margin: 3% 0 0 0;\n    }\n    .close-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .02vw;\n        font-size: 16px;\n        line-height: 30px;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        margin: 2% 0 0 0;\n        color: white;\n    }\n    .option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: start;\n    }\n    .close-option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .close-btn{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        border: none;\n        background-color: black;\n        padding-top: 2.5%;\n        padding-bottom: 2.5%;\n        border: none;\n    }\n    .close-img{\n        height: 13px;\n        width: auto;\n        margin-right: 6%;\n    }\n    .highlight{\n        width: 100%;\n        height: 3px;\n    }\n    .share-container {\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;\n    }\n    /* Menu open state */\n    .share-container.visible {\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n    }\n    /* Menu closing state */\n    .share-container.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n}\n@media screen and (min-width: 1900px){\n    .beer-share-container{\n        background-color: none;\n        display: flex;\n        position: fixed;\n        z-index: 5;\n        left: 25%;\n        top: 8.76vh;\n        width: 190px;\n        height: auto;\n        align-items: center;\n        justify-content: center;\n        border: none;\n      }\n    .beer-sub-container{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        top: 0vh;\n        border: none;\n        width: 100%;\n        height: auto;\n        background-color: rgb(255, 255, 255);\n        box-shadow: 1px 1px 5px rgb(138, 138, 138);\n    }\n    .fb, .linked, .email, .url{\n        width: 75%;\n        padding-top: 9.25%;\n        padding-bottom: 9.25%;\n        background-color: rgba(255, 255, 255, 0);\n        display: flex;\n        align-items: center;\n        justify-content: end;\n    }\n    .url, .fb, .email{\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n        border-bottom: 1px solid rgb(220, 221, 221);\n    }\n    .linked{\n        border: 0;\n    }\n    .url-img{\n        height: 20px;\n        width: auto;\n        margin-right: 14%;\n    }\n    .fb-img{\n        height: 23px;\n        width: auto;\n        margin-right: 13%;\n    }\n    .email-image{\n        height: 15px;\n        margin-right: 14%;\n    }\n    .menu-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .25px;\n        font-size: 17px;\n        line-height: 24px;\n        display: flex;\n        padding: 0;\n        margin: 3% 0 0 0;\n    }\n    .close-label{\n        font-family: 'Helvetica-Reg';\n        font-weight: 500;\n        letter-spacing: .25px;\n        font-size: 17px;\n        line-height: 30px;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        margin: 2.25% 0 0 0;\n        color: white;\n    }\n    .option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: start;\n    }\n    .close-option{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .close-btn{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        border: none;\n        background-color: black;\n        padding-top: 4.25%;\n        padding-bottom: 4.25%;\n        border: none;\n    }\n    .close-img{\n        height: 15px;\n        width: auto;\n        margin-right: 6%;\n    }\n    .highlight{\n        width: 100%;\n        height: 3px;\n    }\n    .share-container {\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity .3s ease-in-out, visibility 0.3s ease-in-out;\n    }\n    /* Menu open state */\n    .share-container.visible {\n        display: flex;\n        opacity: 1;\n        visibility: visible;\n    }\n    /* Menu closing state */\n    .share-container.hidden {\n        opacity: 0;\n        visibility: hidden;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
